import { render, staticRenderFns } from "./testIndex.vue?vue&type=template&id=0e0e3dad&scoped=true"
import script from "./testIndex.vue?vue&type=script&lang=js"
export * from "./testIndex.vue?vue&type=script&lang=js"
import style0 from "./testIndex.vue?vue&type=style&index=0&id=0e0e3dad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0e3dad",
  null
  
)

export default component.exports